import { Controller } from "@hotwired/stimulus"
import { trackLinkClick } from "../modules/music/ga4_tracker"

// Fires a GA4 event when a tracked music link is clicked (per-platform / per-kind),
// so we can see which streaming services / CTAs convert. No-ops if GA4 isn't loaded.
// Usage:
//   data-controller="music-analytics"
//   <a data-action="click->music-analytics#track" data-platform="spotify" data-kind="listen">
export default class extends Controller {
  track(event) {
    const el = event.currentTarget
    trackLinkClick((el.dataset.platform || "").toString(), (el.dataset.kind || "link").toString())
  }
}
